// @ constants
const {
    AMOUNT_TARGET_TYPE,
    INTERVENER_TYPE,
    TEXT_TARGET_TYPE
} = require('constants/index');

module.exports = {
    setSuccessStepPrefix: 'combinedDeposit_setSuccessStepPrefix',
    setSuccessAdditionalInfo: 'combinedDeposit_setSuccessStepAdditionalInfo',
    title: 'contractSummary-contractSummary_combinedDepositSuccessTitle',
    pending_title: 'contractSummary-contractSummary_combinedDepositPendingTitle',
    backButtonText: 'contractSummary-backToDeposits',
    backButtonUrl: '/myprofile/deposits',
    details: [
        [
            {
                className: 'contract-summary__border-separator',
                columns: 5,
                details: [
                    {
                        columns: 12,
                        title: 'contractSummary-contractSummary_noNewMoneyDepositNotRenewDeposit'
                    },
                    {
                        columns: 12,
                        target: 'monto_traspasar',
                        title: 'contractSummary-requestedAmount',
                        type: AMOUNT_TARGET_TYPE
                    },
                ]
            },
            {
                columns: 6,
                offset: 1,
                details: [
                    {
                        columns: 12,
                        type: INTERVENER_TYPE,
                        title: 'contractsView-interveners',
                        interveners: []
                    },
                    {
                        columns: 12,
                        field: 'description',
                        target: 'cta_seleccionada',
                        title: 'contractSummary-associatedAccount',
                        type: TEXT_TARGET_TYPE
                    },
                    {
                        columns: 12,
                        source: 'account',
                        target: 'balance',
                        title: 'contractSummary-balanceAssociatedAccount',
                        type: AMOUNT_TARGET_TYPE
                    }
                ]
            }
        ]
    ],
    renewable_details: [
        [
            {
                className: 'contract-summary__border-separator',
                columns: 5,
                details: [
                    {
                        columns: 12,
                        title: 'contractSummary-contractSummary_noNewMoneyDepositRenewDeposit'
                    },
                    {
                        columns: 12,
                        target: 'monto_traspasar',
                        title: 'contractSummary-requestedAmount',
                        type: AMOUNT_TARGET_TYPE
                    },
                ]
            },
            {
                columns: 6,
                offset: 1,
                details: [
                    {
                        columns: 12,
                        type: INTERVENER_TYPE,
                        title: 'contractsView-interveners',
                        interveners: []
                    },
                    {
                        columns: 12,
                        field: 'description',
                        target: 'cta_seleccionada',
                        title: 'contractSummary-associatedAccount',
                        type: TEXT_TARGET_TYPE
                    },
                    {
                        columns: 12,
                        source: 'account',
                        target: 'balance',
                        title: 'contractSummary-balanceAssociatedAccount',
                        type: AMOUNT_TARGET_TYPE
                    }
                ]
            }
        ]
    ],
    pending_details: [
        [
            {
                className: 'contract-summary__border-separator',
                columns: 5,
                details: [
                    {
                        columns: 12,
                        title: 'contractSummary-contractSummary_noNewMoneyDepositNotRenewDeposit'
                    },
                    {
                        columns: 12,
                        target: 'monto_traspasar',
                        title: 'contractSummary-requestedAmount',
                        type: AMOUNT_TARGET_TYPE
                    },
                ]
            },
            {
                columns: 6,
                offset: 1,
                details: [
                    {
                        columns: 12,
                        type: INTERVENER_TYPE,
                        title: 'contractsView-interveners',
                        interveners: []
                    },
                    {
                        columns: 12,
                        field: 'description',
                        target: 'cta_seleccionada',
                        title: 'contractSummary-associatedAccount',
                        type: TEXT_TARGET_TYPE
                    },
                    {
                        columns: 12,
                        source: 'account',
                        target: 'balance',
                        title: 'contractSummary-balanceAssociatedAccount',
                        type: AMOUNT_TARGET_TYPE
                    }
                ]
            }
        ]
    ],
    renewable_pending_details: [
        [
            {
                className: 'contract-summary__border-separator',
                columns: 5,
                details: [
                    {
                        columns: 12,
                        title: 'contractSummary-contractSummary_noNewMoneyDepositRenewDeposit'
                    },
                    {
                        columns: 12,
                        target: 'monto_traspasar',
                        title: 'contractSummary-requestedAmount',
                        type: AMOUNT_TARGET_TYPE
                    },
                ]
            },
            {
                columns: 6,
                offset: 1,
                details: [
                    {
                        columns: 12,
                        type: INTERVENER_TYPE,
                        title: 'contractsView-interveners',
                        interveners: []
                    },
                    {
                        columns: 12,
                        field: 'description',
                        target: 'cta_seleccionada',
                        title: 'contractSummary-associatedAccount',
                        type: TEXT_TARGET_TYPE
                    },
                    {
                        columns: 12,
                        source: 'account',
                        target: 'balance',
                        title: 'contractSummary-balanceAssociatedAccount',
                        type: AMOUNT_TARGET_TYPE
                    }
                ]
            }
        ]
    ],
    warningMessage: [
        [
            {
                text: 'contractSummary-contractSummary_noNewMoneyDepositNoMailMessage'
            }
        ]
    ],
    successWithEmail_warningMessage: [
        [
            {
                text: 'contractSummary-contractSummary_noNewMoneyDepositMailMessage'
            }
        ]
    ],
    pending_warningMessage: [
        [
            {
                text: 'contractSummary-contractSummary_noNewMoneyDepositNoMailMessage'
            }
        ]
    ],
    pending_successWithEmail_warningMessage: [
        [
            {
                text: 'contractSummary-contractSummary_noNewMoneyDepositMailMessage'
            }
        ]
    ],
}
